export default __webpack_public_path__ + "28b33cb935ffd04d41d33e87df8ea185.jpg";